import { IAssertPayload } from './i_assert_payload';

export class ERROR__with_assert_data extends Error {
  // You can add any additional properties you want
  assert_payload: IAssertPayload;
  assert_type: string;

  /*
   * METHODS
   */

  constructor(assert_type: string = '', assert_payload: IAssertPayload = {}) {
    super(''); // Pass the message to the Error constructor

    this.assert_type = assert_type;
    this.name = this.constructor.name; // Set the name of the error class
    this.assert_payload = assert_payload; // Assign the additional data

    Error.captureStackTrace(this, this.constructor); // Capture the stack trace (for V8 engines like Chrome)
  }
}
